module.exports = __webpack_public_path__ + "static/media/P52_Circular.7a0c475f.svg";